/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Discovery_LinkInputs */



/**
* | output |
* | --- |
* | "Explore Community" |
*
* @param {Tournaments_Discovery_LinkInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_discovery_link = /** @type {((inputs?: Tournaments_Discovery_LinkInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Discovery_LinkInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Explorer la communauté")
	if (locale === "es") return /** @type {LocalizedString} */ ("Explorar la comunidad")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Explorar a comunidade")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esplora la comunità")
	return /** @type {LocalizedString} */ ("Explore Community")
});